"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.concatTransformDependencies = void 0;

var _dependenciesIsIntegerGenerated = require("./dependenciesIsInteger.generated.js");

var _dependenciesMatrixGenerated = require("./dependenciesMatrix.generated.js");

var _dependenciesTypedGenerated = require("./dependenciesTyped.generated.js");

var _factoriesAny = require("../../factoriesAny.js");

/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
var concatTransformDependencies = {
  isIntegerDependencies: _dependenciesIsIntegerGenerated.isIntegerDependencies,
  matrixDependencies: _dependenciesMatrixGenerated.matrixDependencies,
  typedDependencies: _dependenciesTypedGenerated.typedDependencies,
  createConcatTransform: _factoriesAny.createConcatTransform
};
exports.concatTransformDependencies = concatTransformDependencies;